import React from "react";
import { getColor } from "../../utils/color";
import { getAddSizeUnit } from "../../utils/size";
import { classnames } from "../../utils/text";

const Loading = ({
  isFull = false,
  color = `#1DE9B6`,
  minHeight = 300,
  children
}) => {
  return (
    <div
      className={classnames(`loading-wrap`, {
        'loading-full-page': isFull
      })}
      style={{
        minHeight: getAddSizeUnit(minHeight)
      }}
    >
      <div className="loading">
        <div className="inline-block">
          <svg
            className="spinner"
            width="100px"
            height="100px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className="path"
              fill="none"
              stroke={getColor(color)}
              strokeWidth="6"
              strokeLinecap="round"
              cx="33" cy="33" r="30"
            ></circle>
          </svg>
        </div>
        {children &&
          <span className={classnames("loading-text")}>
            {children}
          </span>
        }
      </div>
    </div>
  );
};

export default Loading;
